<div class="review-vet-profile" [hidden]="viewMode !== 'NotificationDetail'">
  <app-notification-template 
                             [allowGrouping]="false"
                             [allowDisableSubmit]="false"
                             [inputRecipients]="recipients"
                             [inputMessageTemplate]="messageTemplate"
                             (onSubmit)="onSubmit()"
                             (onCancel)="onCancel()"></app-notification-template>
</div>

<div class="review-vet-profile" [hidden]="viewMode !== 'Submit'">

  <div class="modal-header sticky-header">

    <div class="row">
      <h5 class="modal-title align-self-center col-auto" id="profileModalLabel">Profile <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>--></h5>
      <div class="col text-end pt-3">

        <button type="button"
                class="btn btn-secondary me-2"
                (click)="closePopup()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button class="btn btn-danger me-2"
                [disabled]="isRequestUnavailable || isDenyLoading"
                (click)="deniedClick()">
          <i class="fa fa-spinner fa-spin" *ngIf="isDenyLoading"></i>
          Deny
        </button>
        <span class="btn btn-outline-primary me-2" [ngClass]="{'disable-container': isRequestUnavailable || messageTemplate?.notificationTypeId == 0}">
          <input type="checkbox" [(ngModel)]="allChecked" id="autoNotifySub"
                 [disabled]="isRequestUnavailable"
                 class="me-2" />
          <label class="clickable-label" (click)="changeViewModeToNotification()">
            Auto Notify
            ({{recipientsCount}}) Vet
          </label>
        </span>


        <button type="button"
                class="btn btn-primary btn-primary-color"
                [disabled]="isRequestUnavailable || isDenyLoading || (!deniedClicked && !approvedClicked)"
                (click)="submitReview()">
          <i class="fa fa-save"></i> Approve
        </button>
      </div>
    </div>
    <div class="alert alert-warning mt-3 mb-0" role="alert" *ngIf="isRequestUnavailable">
      <i class="fa fa-exclamation-triangle me-2"></i>{{ requestUnavailableMessage }}
    </div>
    <div class="row container py-5" style="padding-top:5px !important; padding-bottom:20px !important;">
      <div class="row  text-center">
        <label class="col-sm-3 ps-0 align-self-center text-start col-form-label">
          Grant Vet Access to
        </label>
      </div>
    </div>
    <div class="row container py-5" style="padding-top:0px !important; padding-bottom:5px !important">
      <div class="row  text-center">
        <!-- View Access -->
        <div class="col-md-3 access-item">
          <div class="d-flex flex-column align-items-center form-check-lg">
            <label class="form-check-label mb-3" for="view-access" style="margin-bottom: 5px !important">
              View Access
            </label>
            <input class="form-check-input"
                   type="checkbox"
                   id="view-access"
                   [(ngModel)]="memberviewAccess"
                   [disabled]="membersubmitAccess">
          </div>
        </div>

        <!-- Submit Access -->
        <div class="col-md-3 access-item">
          <div class="d-flex flex-column align-items-center form-check-lg">
            <label class="form-check-label mb-3" for="submit-access" style="margin-bottom: 5px !important">
              Submit Access
            </label>
            <input class="form-check-input"
                   type="checkbox"
                   id="submit-access"
                   [(ngModel)]="membersubmitAccess"
                   (change)="onSubmitAccessChange()">
          </div>
        </div>

        <!-- Apply to All Sales -->
        <div class="col-md-3 access-item">
          <div class="d-flex flex-column align-items-center form-check-lg">
            <label class="form-check-label mb-3" for="apply-all-sales" style="margin-bottom:5px !important">
              Apply to All Sales
            </label>
            <input class="form-check-input"
                   type="checkbox"
                   id="apply-all-sales"
                   [(ngModel)]="memberAllSaleAccess">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="user-profile">
      <div class="container-fluid p-0">
        <div class="bg-white p-2">
          <div class="modal-body-vet-profile">
            <app-review-profile-info [data]="data" class="d-flex justify-content-center w-100"></app-review-profile-info>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
